import {Button} from '@/components/ui/button/Button'
import {DotsHorizontalIcon} from '@/components/ui/icon/Icon'
import {Menu, MenuItem} from '@/components/ui/menu-atoms/MenuAtoms'
import {DeleteAgendaEventButton} from '@/features/agenda/components/delete-agenda-event-button/DeleteAgendaEventButton'
import {EditEventFormDialog} from '@/features/agenda/components/edit-event-form-dialog/EditEventFormDialog'
import {useEventFormDefaultValues} from '@/features/agenda/hooks/useEventFormDefaultValues'
import {AgendaEventType} from '@/features/agenda/types'
import {useTheme} from 'styled-components'
import {MenuButton, MenuProvider} from '@ariakit/react'
import {useMemo} from 'react'
import {AgendaEventTreatmentSchema} from '@/features/agenda/formSchemas'

export const AgendaEventDetailsDialogMenu = ({
    agendaEvent,
    repetitionData
}: {
    agendaEvent: Extract<AgendaEventType, {type: 'event'}>
    repetitionData?: AgendaEventTreatmentSchema['repetitionData']
}) => {
    const theme = useTheme()
    const {defaultValues} = useEventFormDefaultValues({eventId: agendaEvent.id})

    const canDeleteOrEdit = useMemo(
        () =>
            agendaEvent.status == 'provisional' ||
            agendaEvent.status == 'to_reschedule' ||
            agendaEvent.status == 'scheduled' ||
            agendaEvent.status == 'to_be_confirmed',
        [agendaEvent.status]
    )

    return (
        <MenuProvider>
            <MenuButton
                render={
                    <Button variant="secondary" shape="square" size="md">
                        <DotsHorizontalIcon />
                    </Button>
                }
            />
            <Menu style={{zIndex: theme.zIndex.modal}}>
                {defaultValues && (
                    <MenuItem
                        render={
                            <EditEventFormDialog
                                defaultValues={defaultValues}
                                isRecurringEvent={!!agendaEvent.frequency}
                                isDisabled={!canDeleteOrEdit}
                            />
                        }
                    />
                )}
                <MenuItem render={<DeleteAgendaEventButton event={agendaEvent} repetitionData={repetitionData} />} />
            </Menu>
        </MenuProvider>
    )
}
